import React from 'react';
import Weblayout from './Weblayout';
import PageTransition from '../components/PageTransition';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { appname } from "../variables";

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <PageTransition>
      {/* Passing isLegal={true} swaps the header buttons automatically */}
      <Weblayout isLegal={true}>
        <motion.div 
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          className="bento-item p-0 border-0 bg-white overflow-hidden d-flex flex-column h-100 shadow-lg"
          style={{ borderRadius: '24px' }}
        >
          {/* STICKY DOCUMENT HEADER */}
          <div className="bg-light border-bottom p-4 flex-shrink-0 d-flex justify-content-between align-items-center">
            <div>
              <h2 className="fw-black text-dark m-0">Privacy Policy</h2>
              <small className="text-muted font-monospace">INTERNAL_REF: LEGAL_PRIV_2026_V1</small>
            </div>
            <div className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-3 py-2">
              <i className="bi bi-shield-check me-1"></i> VERIFIED_SECURE
            </div>
          </div>

          {/* SCROLLABLE CONTENT BODY */}
          <div className="p-4 p-md-5 overflow-auto text-dark privacy-content flex-grow-1">
            
            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">01_CORE_PRINCIPLES</h6>
              <h4 className="fw-black text-dark mb-3">Data Integrity & Privacy</h4>
              <p>
                At {appname}, we treat your data as a critical system asset. Our infrastructure is designed as a pass-through node, ensuring that your business communication remains private, secure, and under your total control. 
              </p>
            </section>

            

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">02_COLLECTION_LOGIC</h6>
              <h4 className="fw-black text-dark mb-3">Information We Process</h4>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3 border h-100">
                    <span className="fw-bold d-block text-primary mb-1 small">Account Metadata</span>
                    <p className="small text-muted m-0">Email, billing details, and dashboard credentials required for service provisioning.</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-3 bg-light rounded-3 border h-100">
                    <span className="fw-bold d-block text-primary mb-1 small">Node Telemetry</span>
                    <p className="small text-muted m-0">IP addresses, API request headers, and device tokens used to stabilize your WhatsApp connection.</p>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">03_ZERO_PERSISTENCE</h6>
              <h4 className="fw-black text-dark mb-3">The Message Protocol</h4>
              <p>We operate on a <strong>"Zero-Persistence"</strong> framework for all WhatsApp message payloads:</p>
              <ul className="list-unstyled">
                <li className="mb-3 d-flex gap-2">
                  <i className="bi bi-check-circle-fill text-success"></i>
                  <span><strong>Non-Storage:</strong> Message content (text, media, docs) is never stored in our permanent databases.</span>
                </li>
                <li className="mb-3 d-flex gap-2">
                  <i className="bi bi-check-circle-fill text-success"></i>
                  <span><strong>In-Transit Security:</strong> Every packet is encrypted using TLS 1.3 during the journey from your server to the WhatsApp nodes.</span>
                </li>
                <li className="mb-3 d-flex gap-2">
                  <i className="bi bi-check-circle-fill text-success"></i>
                  <span><strong>Purge Cycle:</strong> Temporary logs used for delivery debugging are automatically destroyed every 168 hours (7 days).</span>
                </li>
              </ul>
            </section>

            <section className="mb-5">
              <h6 className="font-monospace text-primary fw-bold mb-2">04_ENCRYPTION_LAYERS</h6>
              <h4 className="fw-black text-dark mb-3">Storage Safeguards</h4>
              <p>
                Credentials such as WhatsApp Session Data and Third-Party API Keys are stored using <strong>AES-256-GCM encryption</strong>. This data is only decrypted in memory during an active session request and is never exposed in plain text.
              </p>
            </section>

            <section className="mb-4">
              <div className="p-4 rounded-4 bg-dark text-white d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 text-center text-md-start">
                <div>
                  <h5 className="fw-bold m-0">Questions regarding our protocols?</h5>
                  <small className="opacity-75">Connect with our Security Compliance Node for detailed inquiries.</small>
                </div>
                <button className="btn btn-primary rounded-pill px-4 fw-bold" onClick={() => navigate('/contact')}>
                  CONTACT_SECURITY
                </button>
              </div>
            </section>

          </div>
        </motion.div>
      </Weblayout>
    </PageTransition>
  );
}